export const CartActionTypes = {
    TOGGLE_CART_HIDDEN: "TOOGLE_CART_HIDDEN",
    ADD_ITEM: "ADD_ITEM",
    CLEAR_CART_ITEM: "CLEAR_CART_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
};
